import './UserMenuNavLink.scss';

import cn from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import {
  UserMenuNavLinkDefaultProps,
  UserMenuNavLinkPropTypes,
} from './UserMenuNavLink.proptypes';

const UserMenuNavLink = ({ className, context, to, label, disabled }) => {
  const { handleClose } = useHeaderMenuContext();

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      handleClose();
    }
  };

  return (
    <NavLink
      className={cn('user-menu-nav-link', className, {
        'user-menu-nav-link--disabled': disabled,
      })}
      data-qa-id={context || 'user-menu-nav-link'}
      onClick={handleClick}
      to={to}
    >
      <span className="user-menu-nav-link__link-label">{label}</span>
    </NavLink>
  );
};

UserMenuNavLink.defaultProps = {
  ...UserMenuNavLinkDefaultProps,
};

UserMenuNavLink.propTypes = {
  ...UserMenuNavLinkPropTypes,
};

export default UserMenuNavLink;
